import { FC } from "react";
import { FormContainer } from "components/form/form.styles";
import GosDonorInfoStep from "components/gos-donor-info-step/gos-donor-info-step.component";
import GosInstitutionInfo from "components/gos-institution-info/gos-institution-info.component";
import GosSecuritiesStep from "components/gos-securities-step/gos-securities-step.component";

interface Props {
  isContextual: boolean;
}

const GosForm: FC<Props> = ({ isContextual }) => {
  return (
    <FormContainer isContextual={isContextual}>
      <GosDonorInfoStep />
      <GosInstitutionInfo />
      <GosSecuritiesStep />
    </FormContainer>
  );
};

export default GosForm;
